import util from '../lib/util';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
export const Type = {
    Phone: "phone",
    Email: "email",
    Web: "web"
};
export type TypeType = typeof Type[keyof typeof Type];
class Resource extends Base implements EntityType {
    resourceId: uuid;
    type: TypeType;
    label: string;
    value: string;
    canContact: boolean;
    isPrimary: boolean;
    isCurrent: boolean;
    notes?: string | null;
    constructor(doc: typeof Resource | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            resourceId: genUUID(),
            type: null,
            label: null,
            value: null,
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "resource";
        // @ts-ignore
        this.resourceId = doc._resourceId || doc.resourceId || doc.resourceid || genUUID();
        // @ts-ignore
        this.type = doc._type || doc.type || null;
        // @ts-ignore
        this.label = doc._label || doc.label || null;
        // @ts-ignore
        this.value = doc._value || doc.value || null;
        // @ts-ignore
        this.canContact = util.defaultBoolean([doc.canContact, doc._canContact, doc.cancontact, true]);
        // @ts-ignore
        this.isPrimary = util.defaultBoolean([doc.isPrimary, doc._isPrimary, doc.isprimary, false]);
        // @ts-ignore
        this.isCurrent = util.defaultBoolean([doc.isCurrent, doc._isCurrent, doc.iscurrent, true]);
        // @ts-ignore
        this.notes = doc._notes || doc.notes || null;
    }
    get id(): uuid { return this.resourceId; }
    static TYPE_VALUES = ["phone", "email", "web"];
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique ID for this resource"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","mergeStrategy":"immutable","comment":"Associated firm"}]; }
    toLowerCase() { return this.resourceId; }
    displayFn() { return `${this.label} ${this.type}: ${this.value}`; }
    static override getNonRefArrayFields(): string[] { return []; }
    static override getDefaultEntries(): Resource[] {
        return [];
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'resource',
    table: 'RESOURCE',
    comment: 'A contact method — phone number, email address, or website URL — belonging to a contact or other entity. Each record stores the type, a categorizing label (e.g. mobile, home, business), the actual value, and flags for primary, current, and do-not-contact status. Changes are propagated to the payment processor after save.',
    fields: {
        resourceId: {type: 'uuid', required: true, pk: true, default: '__UUID__', comment: 'Unique ID for this resource'},
        type: {type: 'string', required: true, values: ['phone', 'email', 'web'], comment: 'The type of resource: phone, email, or web'},
        label: {type: 'string', required: true, comment: 'A non-unique label for the resource, e.g. Home'},
        value: {type: 'string', required: true, comment: 'The value of the resource, e.g. an email or phone number'},
        canContact: {type: 'boolean', default: true, comment: 'Can the person/entity be contacted with this information?'},
        isPrimary: {type: 'boolean', default: false, comment: 'Is this the primary resource (of this type)?'},
        isCurrent: {type: 'boolean', default: true, comment: 'Is this resource current?'},
        notes: {type: 'string', required: false, comment: 'Notes on this resource, to help differentiate'}
    },
    displayFn: "`${this.label} ${this.type}: ${this.value}`",
    indexes: [
        {
            name: 'notDeleted', fn: t => t.status !== 'D'
        }
    ],
    maps: [
        {
            name: 'entityId',
            keysFn: t => t.entityId,
            presentFn: (t, k) => t.entityId === k && t.status !== 'D'
        }
    ],
    hooks: [
        {when: 'after', appliesTo: 'save', method: 'updatePaymentProcessor', async: true}
    ]
});
    }
}
export default Resource;
